__webpack_require__.p = "https://www.ikea.com/bh/ar/local-apps/alsulaiman-purchase-handler/";